<template>
  <v-data-table
    :headers="headers"
    :items="scheduleInfo"
    :search="search"
    class="elevation-3"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-row>
          <v-toolbar-title>Schedule Sales</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-btn small icon class="pt-1" @click="updateScheduleInfo()">
            <v-icon>mdi-cached</v-icon>
          </v-btn>
          <vue-json-to-csv
              :json-data   = scheduleInfo>
              <button  small icon class="pt-1">
                <v-icon>mdi-arrow-collapse-down</v-icon>
              </button>
          </vue-json-to-csv>
          <v-spacer></v-spacer>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="dates"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
            <v-date-picker
              v-model="dates"
              no-title
              scrollable
              range
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="updateTableOnDateChange(dates)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-col cols="8" sm="3" class="pt-0 pb-0">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field
          ></v-col>
        </v-row>
      </v-toolbar>
    </template>
    <template v-slot:[`item.date`]="{ item }">
      {{ new Date(item.date).toDateString() }}
    </template>
    <template v-slot:[`item.totalRevenue`]="{ item }">
      {{
        item.totalRevenue.toLocaleString("en-IE", {
          style: "currency",
          currency: "EUR",
        })
      }}
    </template>
    <template v-slot:[`item.spendPerHead`]="{ item }">
      {{ (item.totalRevenue / item.players).toLocaleString("en-IE", {
          style: "currency",
          currency: "EUR",
        }) }}
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ReportingSchedulesTable",
  computed: {
    ...mapGetters(["getBookSales", "getScheduleInfo"]),
    dateRangeText () {
        return this.dates.join(' ~ ')
      },
    scheduleInfo() {
      let schedules = [];
      for (let i = 0; i < this.getScheduleInfo.length; i++) {
        let scheduleInfo = {};
        const schedule = this.getScheduleInfo[i];
        scheduleInfo.date = schedule.date;
        scheduleInfo.title = schedule.title;
        let scheduleProducts = this.getBookSales.filter(
          (product) => product.schedule_id == schedule.id
        );
        let singles = 0;
        let doubles = 0;
        let flyers = 0;
        let totalRevenue = 0;
        for (let i = 0; i < scheduleProducts.length; i++) {
          if (scheduleProducts[i].flyer) {
            flyers =
              flyers +
              scheduleProducts[i].singles +
              scheduleProducts[i].doubles;
          } else {
            singles += scheduleProducts[i].singles;
            doubles += scheduleProducts[i].doubles;
          }
          totalRevenue +=
            scheduleProducts[i].singles * scheduleProducts[i].price;
          totalRevenue +=
            scheduleProducts[i].doubles * scheduleProducts[i].double_price;
        }
        scheduleInfo.singles = singles;
        scheduleInfo.doubles = doubles;
        scheduleInfo.flyers = flyers;
        scheduleInfo.players = schedule.num_players;
        scheduleInfo.totalRevenue = totalRevenue;
        schedules.push(scheduleInfo);
      }
      return schedules;
    },
  },
  data: () => ({
    search: "",
    dates: [(new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1)).toISOString().substr(0, 10),
    (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0)).toISOString().substr(0, 10)],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    headers: [
      {
        text: "Date",
        align: "start",
        value: "date",
      },
      {
        text: "Schedule Title",
        align: "start",
        value: "title",
      },
      { text: "Singles Sold", value: "singles" },
      { text: "Doubles Sold", value: "doubles" },
      { text: "Flyers Sold", value: "flyers" },
      { text: "Number of Players", value: "players" },
      { text: "Total Revenue", value: "totalRevenue" },
      { text: "Spend Per Head", value: "spendPerHead" },
    ],
  }),

  created() {
    if (this.getBookSales.length == 0) {
      this.fetchGameSales(this.dates);
    }
    this.fetchScheduleInfo(this.dates);
  },
  methods: {
    ...mapActions(["fetchGameSales", "fetchScheduleInfo"]),
    updateScheduleInfo() {
      this.fetchScheduleInfo(this.dates);
    },
    selectTemplate(template) {
      this.setSelectedTemplate(template);
      this.$emit("templateSelected");
    },
    updateTableOnDateChange(dates) {
      this.updateScheduleInfo();
      this.$refs.menu.save(dates)
    }
  },
};
</script>

<style scoped>
.logo {
  max-height: 25px;
}

.square {
  width: 1.25vw;
  height: 1.25vw;
  min-width: 10px;
  min-height: 10px;
  border: rgb(73, 73, 73);
  border-style: solid;
  border-radius: 0.5px;
}

.fluid-container {
  display: flex;
}
</style>